var map = {
	"./jiangzhuang (1).jpg": 5123,
	"./jiangzhuang (2).jpg": 4126,
	"./jiangzhuang (3).jpg": 4651,
	"./jiangzhuang (4).jpg": 1564,
	"./jiangzhuang (5).jpg": 8977,
	"./jiangzhuang (6).jpg": 4842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6051;